/** See `src/i18n/locales/en/managePilots.ts`. */
export const managePilots = {
  page: {
    title: 'Pilots',
    lead: 'Alle pilots op het platform, filterbaar op bedrijf en status.',
    filterCompany: 'Bedrijf',
    filterStatus: 'Status',
    allCompanies: 'Alle bedrijven',
    allStatuses: 'Alle statussen',
    empty: 'Geen pilots voldoen aan deze filters.',
    rowsLabel: 'de pilots',
    company: 'Bedrijf',
    name: 'Naam',
    status: 'Status',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    departments: 'Afdelingen',
  },
  status: {
    draft: 'Concept',
    baseline: 'Nulmeting',
    active: 'Actief',
    interim_review: 'Tussentijdse evaluatie',
    final_review: 'Eindevaluatie',
    completed: 'Afgerond',
    scaled: 'Opgeschaald',
  },
} as const;
